import { render, staticRenderFns } from "./SkuInfo.vue?vue&type=template&id=3588eaac&scoped=true"
import script from "./SkuInfo.vue?vue&type=script&lang=js"
export * from "./SkuInfo.vue?vue&type=script&lang=js"
import style0 from "./SkuInfo.vue?vue&type=style&index=0&id=3588eaac&prod&scoped=true&lang=scss"
import style1 from "./SkuInfo.vue?vue&type=style&index=1&id=3588eaac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588eaac",
  null
  
)

export default component.exports